'use client';

import { Button } from '@zillow/constellation-10';
import { Bell } from 'lucide-react';

import { LucideIcon } from '@/src/components/LucideIcon';
import { useOptionalSrpSaveSearch } from './SrpSaveSearchProvider';

export function SrpSaveSearchButton() {
  const saveSearch = useOptionalSrpSaveSearch();

  if (!saveSearch) {
    return null;
  }

  const { isSaved, isDisabled, label, handleToggle } = saveSearch;
  const handleClick = () => {
    if (!isDisabled) {
      handleToggle();
    }
  };

  const icon = <LucideIcon icon={Bell} size="sm" fill={isSaved ? 'currentColor' : 'none'} />;

  return (
    <Button
      data-testid="button-save-search"
      type="button"
      tone="brand"
      emphasis="bare"
      size="sm"
      icon={icon}
      iconPosition="start"
      css={{
        borderRadius: 'pill',
        whiteSpace: 'nowrap',
      }}
      onClick={handleClick}
      disabled={isDisabled}
      aria-pressed={isSaved}
    >
      {label}
    </Button>
  );
}
